import Slideshow from './slideshow';
import Dialog from './dialog';
import Scene from './scene';
import Survey from './survey';
import StepPractice from './step-practice';
import InteractiveVideo from './interactive-video';

export default {
  Slideshow,
  Dialog,
  Scene,
  Survey,
  StepPractice,
  InteractiveVideo
};
